var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.4 12.7h2v6.5h-2v-6.5Zm-3-1.5h2v8h-2v-8Zm-6.25 7.5a3.754 3.754 0 0 1-3.75-3.75h1.5a2.25 2.25 0 1 0 2.25-2.25v-1.5a3.75 3.75 0 1 1 0 7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21 1.5H3A1.502 1.502 0 0 0 1.5 3v18A1.501 1.501 0 0 0 3 22.5h18a1.502 1.502 0 0 0 1.5-1.5V3A1.502 1.502 0 0 0 21 1.5ZM20.5 8h-10V3.5h10V8ZM9 3.5V8H3.5V3.5H9Zm-5.5 17V9.75h17V20.5h-17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVica);
export default __webpack_public_path__ + "static/media/vica.b9fb683a5ce230856f0c59925d6d271a.svg";
export { ForwardRef as ReactComponent };